import { productAddToCartButtonStyles } from "@insite/content-library/Components/ProductAddToCartButton";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

productAddToCartButtonStyles.variant = "tertiary";

export const addToCartButtonGridStyle = css`
    width: 60%;
    padding: 0 12px 0 12px;
    text-transform: uppercase;
    ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            null,
            null,
            null,
            css`
                width: 50%;
            `,
            null,
        ])}
`;
export const qtyGridStyle = css`
    width: 40%;
    background-color: #e3e3e3;
    flex-direction: row;
    align-items: center;
    padding: 5px;
    ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            null,
            null,
            null,
            css`
                width: 50%;
            `,
            null,
        ])}
    & div input[type='number'] {
        height: 30px;
        border-radius: 4px;
        text-align: center;
        font-size: 16px;
    }
    div {
        margin-top: 0 !important;
    }
    & label {
        font-weight: normal;
        font-size: 12px;
        padding: 6px;
        flex-basis: 85%;
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            null,
            null,
            null,
            null,
            css`
                    flex-basis: 60%;
                `,
        ])}
    }
`;
